import { render, staticRenderFns } from "./OasisPark.vue?vue&type=template&id=65fdd990&scoped=true&"
import script from "./OasisPark.vue?vue&type=script&lang=js&"
export * from "./OasisPark.vue?vue&type=script&lang=js&"
import style0 from "@/assets/scss/mobile/static-pages/oasis-park.scss?vue&type=style&index=0&id=65fdd990&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65fdd990",
  null
  
)

export default component.exports